// @vendors
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';

// @components
import FooterAdvice from './../components/FooterAdvice/FooterAdvice'

// @utilities
const { FormattedText } = require('core/i18n').i18n;
import Storage from 'utilities/storage';

// @constants
import { RENEW_TOKEN } from 'constants/aggregator/psd2DecoupledFlowType';
import { PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';

class AggregatorPSD2ExpiredTokenAdvice extends Component {

    handleButtonClick = () => {
        const { existSeveralBanks, bankCode, history } = this.props

        if (existSeveralBanks) {
            history.push('/myprofile/global/entities/manage')
        } else {
            Storage.localStorage.set(PSD2_FLOW_TYPE, RENEW_TOKEN)
            history.push(`/myprofile/global/entities/add/credentials/${bankCode}`)
        }
    }

    render() {
        const { bankName, existSeveralBanks } = this.props;

        return (
            <FooterAdvice
                title={<FormattedText
                    value={`aggregatorPSD2ExpiredTokenAdvice-${existSeveralBanks ? 'genericTitle' : 'title'}`}
                    injectedStrings={[bankName]}
                />}
                description={<FormattedText
                    value={`aggregatorPSD2ExpiredTokenAdvice-${existSeveralBanks ? 'genericDescription' : 'description'}`}
                    injectedStrings={[bankName]}
                />}
                textButton={<FormattedText value={`aggregatorPSD2ExpiredTokenAdvice-${existSeveralBanks ? 'genericTextButton' : 'textButton'}`} />}
                onClickButton={this.handleButtonClick}
            />
        )
    }
}

AggregatorPSD2ExpiredTokenAdvice.propTypes = {
    bankCode: PropTypes.string.isRequired,
    bankName: PropTypes.string.isRequired,
    existSeveralBanks: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
}

export default withRouter(AggregatorPSD2ExpiredTokenAdvice);
